// bao migrate skip
import * as ko from "knockout";
import * as moment from "moment";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoMenu from "./../services/bao-menu";
import Guid from "./../factories/guid";
import baoRouter from "./../services/bao-router";
import BaoDialog from "./../factories/bao-dialog";
import finitoService from "./../services/finito-service";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import appTabController from "./../services/app-tab-controller";
import InstructionAttachmentModel from "./../factories/instruction-attachment";
import TaskHistoryViewModel from "./task-history";
import SendMailDialog from "./../factories/send-mail-dialog";
import InstructionShiftbookDialog from "./dialogs/instruction-shiftbook-dialog";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../bindings/visibility";
import "./../bindings/element";
import "./../bindings/bao-tabs";
function TaskViewModel(tabPage) {
    var self = this;
    SubscriptionViewModel.call(self, tabPage);
    self.InstructionSerial = {
        SerialText: ko.observable()
    };
    self.InstructionSerialId = ko.observable(),
        self.AppTabController = appTabController;
    self.SeriesMode = ko.observable(true);
    self.EditSerialDefinition = ko.observable(false);
    self.TextModuleField = ko.observable();
    self.Priorities = ko.observableArray();
    self.Categories = ko.observableArray();
    self.SessionTabId = ko.observable();
    self.Instructionrecipients = ko.observableArray();
    self.ShowStatusDialog = ko.observable();
    self.ElementDateTimePickerStart = ko.observable();
    self.ElementDateTimePickerEnd = ko.observable();
    self.FormName = ko.observable();
    self.ReportId = ko.observable();
    self.InstructionId = ko.observable();
    self.ShiftbookId = ko.observable();
    self.ShiftbookName = ko.observable();
    self.Revision = ko.observable();
    self.SelectedRecipients = ko.observableArray();
    self.EditRecipientsPermissionKey = "TaskReportCustomToolbarRecipientsEdit";
    self.HasRecipientsEditPermission = Bao.Session.HasPermission(self.EditRecipientsPermissionKey, window.FinitoApplicationId);
    self.IsRecipientsListEditable = ko.observable(false);
    self.InstructionAttachment = ko.observableArray().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.SelectedTextModule = ko.observable();
    self.showUserTaggingControl = ko.observable(true);
    self.showTextModuleDialog = function () { };
    self.openRecipientSearcher = function () { };
    self.showAttachmentDialog = function () { };
    self.uploadAttachment = function () { };
    self.AreaId = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.AreaName = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.AreaEquipmentId = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.AreaEquipmentBinding = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.Device3NameBinding = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.Device3Id = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.Device4NameBinding = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.Device4Id = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.IgnoreDeviceChanges = ko.observable(true);
    self.ApproverUserId = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.ApproverUserFullName = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.ApprovalStateId = ko.observable();
    self.SubTabsSaveFn = [];
    self.InfoId = ko.observable();
    self.RawValue = ko.observable("");
    self.UserTaggingList = ko.observableArray();
    self.TaskBooks = ko.observableArray([]);
    self.SelectedTaskBookId = ko.observable();
    self.LinkItemToInfoFn = function () { };
    self.GetClosedDateFormatted = ko.pureComputed(function () {
        return moment(self.ClosedDateHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
    });
    self.GetPublishDateFormatted = ko.pureComputed(function () {
        return moment(self.PublishDateHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
    });
    self.ShowIsInProgressAlert = ko.pureComputed(function () {
        var clo = self.IsClosed();
        var inPr = self.IsInProgress();
        let isSeriesMode = self.SeriesMode();
        return ((inPr === true) && (clo == null || clo === false) && !isSeriesMode);
    });

    self.ShowIsPublishedAlert = ko.pureComputed(function () {
        var pub = self.IsPublished();
        var clo = self.IsClosed();
        var inPr = self.IsInProgress();
        let isSeriesMode = self.SeriesMode();
        return ((pub === true) && (clo == null || clo === false) && ((inPr == null || inPr == false) || isSeriesMode));
    });
    self.Device4Id.subscribe(function () {
        self.SetParentsByDevice4();
    });
    self.Device4NameBinding.subscribe(function () {
        if (!self.TabPage.IsLoading() && self.Device4Id() != null) {
            self.Device4Id(null);
        }
    });
    self.Device3Id.subscribe(function () {
        self.SetParentsByDevice3();
    });
    self.Device3NameBinding.subscribe(function () {
        if (!self.TabPage.IsLoading() && self.Device3Id() != null) {
            self.Device3Id(null);
        }
    });
    self.AreaEquipmentId.subscribe(function () {
        self.SetParentsByAreaEquipment();
    });
    self.AreaEquipmentBinding.subscribe(function () {
        if (!self.TabPage.IsLoading() && self.AreaEquipmentId() != null) {
            self.AreaEquipmentId(null);
        }
    });
    self.AreaId.subscribe(function () {
        self.SetChildrenByArea();
    });
    self.ApproverUserId.subscribe(function () {
        self.ApprovalStateId("4188cd62-7c56-433e-b7fd-a286590cd6fe");
    });
    self.SelectedTextModule.subscribe(function (selectedTextModule) {
        finitoService.InsertAtCursorPositionContentEditable(self.TextModuleField().querySelector("#userTaggingInput"), selectedTextModule.Text);
    });
    self.subscribe(self.SeriesMode, function () {
        self.toggleButtons();
    });
    self.subscribe(self.SelectedRecipients, function (selectedRecipients) {
        if (selectedRecipients && selectedRecipients.length > 0) {
            var recipients = ko.utils.arrayMap(selectedRecipients, function (srs: any) {
                return {
                    UserId: srs.UserId,
                    RoleId: srs.RoleId,
                    ShiftbookId: srs.ShiftbookId ? srs.ShiftbookId : self.ShiftbookId(),
                    ShiftTypeId: srs.ShiftTypeId
                };
            });
            if (recipients && recipients.length > 0) {
                self.addRecipients(recipients);
            }
        }
    });
    self.InstructionAttachment.Filtered = ko.pureComputed(function () {
        var instructionAttachment = self.InstructionAttachment(), revision = self.Revision();
        if (!isNaN(revision)) {
            return ko.utils.arrayFilter(instructionAttachment, function (att: any) {
                return att.DeleteInRevision() === null || att.DeleteInRevision() > self.Revision();
            });
        }
        else {
            return instructionAttachment;
        }
    });
    self.getTaskAttachments = function () {
        return Bao.post("Task/GetAttachments", JSON.stringify({
            sessionTabId: self.SessionTabId()
        })).done(function (data) { });
    };
    self.attachmentAdded = function () {
        self.TabPage.IsLoading(true);
        self.TabPage.DirtyFlag(true);
        self.getTaskAttachments().done(function (data) {
            ko.map.fromJS(data, self.InstructionAttachment);
            self.TabPage.IsLoading(false);
        });
    };
    self.removeAttachment = function (attachment) {
        if (!self.IsHistory()) {
            self.TabPage.IsLoading(true);
            self.TabPage.DirtyFlag(true);
            attachment.DeleteInRevision(self.Revision());
            Bao.post("Task/RemoveAttachment", JSON.stringify({
                sessionTabId: self.SessionTabId(),
                attachmentId: attachment.InstructionAttachmentId(),
                deleteInRevision: self.Revision()
            })).done(function () {
                self.TabPage.IsLoading(false);
            });
        }
    };
    self.removeRecipient = function (recipient) {
        var def = $.Deferred();
        self.TabPage.IsLoading(true);
        self.TabPage.DirtyFlag(true);
        Bao.post("Task/RemoveRecipient", JSON.stringify({
            instructionRecipientId: ko.unwrap(recipient.InstructionRecipientId),
            sessionTabId: self.SessionTabId(),
            taskId: self.InstructionId()
        }), function () {
            self.getRecipients().then(function () {
                self.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    self.removeAllRecipients = function () {
        var def = $.Deferred();
        self.TabPage.IsLoading(true);
        self.TabPage.DirtyFlag(true);
        Bao.post("Task/RemoveAllRecipients", JSON.stringify({
            taskId: self.InstructionId(),
            sessionTabId: self.SessionTabId()
        }), function () {
            self.getRecipients().then(function () {
                self.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    self.BeforeClose = function (fn) {
        if (self.TabPage.DirtyFlag() && self.SaveAllowed() && !self.IsHistory() && !self.IsClosed()) {
            self.shouldSave().then(function (shouldSave) {
                if (shouldSave === true) {
                    self.validate().then(function (isValid) {
                        if (isValid) {
                            self.save(false).then(function () {
                                self.clearSession().then(function () {
                                    fn();
                                });
                            });
                        }
                        else {
                            self.showValidationErrors();
                        }
                    });
                }
                else if (shouldSave === false) {
                    self.clearSession().then(function () {
                            fn();
                    });
                }
                else { }
            });
        }
        else {
            self.clearSession().then(function () {
                fn();
            });
        }
    };
    self.init = function () {
        tabPage.IsLoading(true);
        var def = $.Deferred();
        self.LinkItemToInfoFn = tabPage.UrlData().linkFn;
        self.InstructionId(baoRouter.getRouteValue("id", self.TabPage));
        self.ShiftbookId(baoRouter.getRouteValue("shiftbookid", self.TabPage));
        var infoModel = tabPage.UrlData().InfoModel;
        if (infoModel) {
            self.InfoId(infoModel().InfoId());
            self.ShiftbookId(infoModel().ShiftbookId);
        }
        self.get().then(function () {
            if (self.ShiftbookId() == null && self.IsNew()) {
                var shiftbookDialog = new InstructionShiftbookDialog(tabPage, "Task");
                shiftbookDialog.OpenDialog().then(function (result) {
                    if (result != null) {
                        self.ShiftbookId(result.ShiftbookId);
                        self.InitTask().then(function () {
                            def.resolve();
                        });
                    }
                    else {
                        self.AppTabController.RemoveTab(self.TabPage);
                        def.reject();
                    }
                });
            }
            else {
                self.InitTask().then(function () {
                    def.resolve();
                });
            }
        });
        return def.promise();
    };
    self.InitTask = function () {
        self.TabPage.IsLoading(true);
        var getDef = $.Deferred();
        self.getTaskBooks().then(function () {
            self.get().then(function () {
                if (self.ShiftbookId() != null) {
                    self.SelectedTaskBookId(self.ShiftbookId());
                }
                else {
                    self.ShiftbookId(self.TaskBooks()[0].ShiftbookId);
                    self.SelectedTaskBookId(self.ShiftbookId());
                }
                if (self.InstructionSerialId() != null && self.EditSerialDefinition() === true) {
                    var serialQuestionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgOpenTaskSerialQuestion"));
                    serialQuestionDialog.Buttons([{
                        Title: Bao.Session.GetMessage("msgOpenTask"),
                        Click: function () {
                            self.SeriesMode(false);
                            serialQuestionDialog.DialogResult(true);
                            serialQuestionDialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }, {
                        Title: Bao.Session.GetMessage("msgOpenSeries"),
                        Click: function () {
                            self.SeriesMode(true);
                            serialQuestionDialog.DialogResult(true);
                            serialQuestionDialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }, {
                        Title: Bao.Session.GetMessage("msgCancel"),
                        Click: function () {
                            serialQuestionDialog.DialogResult(false);
                            serialQuestionDialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }]);
                    tabPage.IsLoading(false);
                    serialQuestionDialog.Width(400);
                    serialQuestionDialog.Open();
                    serialQuestionDialog.Closed = function () {
                        getDef.resolve();
                        if (serialQuestionDialog.DialogResult() === true) { }
                        else {
                            tabPage.$TabController.RemoveTab(tabPage);
                        }
                    };
                }
                else {
                    if (self.IsNew() == false) {
                        self.SeriesMode(false);
                    }
                    getDef.resolve();
                }
            });
        });
        return getDef.then(function () {
            return $.when(self.getPriorities(), self.getCategories(), (function () {
                var shiftbookid = self.ShiftbookId();
                if (!shiftbookid) {
                    shiftbookid = baoRouter.getRouteValue("shiftbookid", self.TabPage);
                }
                return Bao.post("Shiftbook/GetPermissionsForShiftbook", JSON.stringify({
                    shiftbookId: shiftbookid
                })).then(function (serverResult) {
                    if (!serverResult)
                        return;
                    self.TaskbookPermissions = serverResult.RoleShiftbookPermissions;
                });
            })());
        }).always(function () {
            tabPage.IsLoading(false);
        });
    };
    self.loaded = function () {
        var def = $.Deferred();
        self.ValidFromHtml.Formatted = ko.pureComputed(function () {
            if (self.ValidFromHtml()) {
                return moment(self.ValidFromHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            }
            else {
                return "";
            }
        });
        self.ValidToHtml.Formatted = ko.pureComputed(function () {
            if (self.ValidToHtml() && !ko.unwrap(self.IsNew)) {
                return moment(self.ValidToHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
            }
            else {
                return "";
            }
        });
        self.registerMenuClick();
        self.toggleButtons();
        self.SetPermissions();
        self.InitializeDateTimePicker();
        self.setTabTitle();
        self.IgnoreDeviceChanges(false);
        self.TabPage.DirtyFlag.reset();
        self.refreshUserTagging();
        if (self.InfoId()) {
            self.TabPage.DirtyFlag(true);
        }
        self.SelectedTaskBookId.subscribe(function () {
            self.TabPage.IsLoading(true);
            self.ShiftbookId(self.SelectedTaskBookId());
            self.getCategories().always(function () {
                self.TabPage.IsLoading(false);
            });
        });
        def.resolve();
        return def.promise();
    };
    self.SetPermissions = function (showBtnsFn) {
        var permissions = self.TaskbookPermissions;
        if (!permissions)
            return;
        self.IsRecipientsListEditable(permissions[self.EditRecipientsPermissionKey] && self.HasRecipientsEditPermission());
        if (this.SeriesMode()){
            permissions["TaskInProgress"] = false;
        }

        for (var actionKey in permissions) {
            if (self.boaToolbar2ShowButton) {
                self.boaToolbar2ShowButton(actionKey, permissions[actionKey]);
            }
            if (showBtnsFn) {
                showBtnsFn(actionKey, permissions[actionKey]);
            }
            BaoMenu.permissionVisible({
                ActionKey: actionKey,
                Context: self.TabPage.Context(),
                Visible: permissions[actionKey]
            });
        }
    };
    self.refreshUserTagging = function () {
        var self = this;
        self.showUserTaggingControl(false);
        self.showUserTaggingControl(true);
    }
    self.InitializeDateTimePicker = function () {
        if (ko.unwrap(this.IsHistory) === true) {
            return; // es gbit keinen datepicker in history-version
        }
        let dpStart = $(this.ElementDateTimePickerStart()).parent().data("DateTimePicker");
        let dpEnd = $(this.ElementDateTimePickerEnd()).parent().data("DateTimePicker");
        dpStart.options({ useCurrent: false });
        dpEnd.options({ useCurrent: false });
        
        let fromDate = moment(ko.unwrap(this.ValidFromHtml), Bao.Utils.DateTimeFormat);
        let toDate = moment(ko.unwrap(this.ValidToHtml), Bao.Utils.DateTimeFormat);

        if (fromDate.isValid()) {
            dpEnd.minDate(fromDate);
        }
        if (toDate.isValid()) {
            dpStart.maxDate(toDate);
        }
        $(this.ElementDateTimePickerStart()).parent().on("dp.change", (e: any) => {
           dpEnd.minDate(e.date);
        });
        $(this.ElementDateTimePickerEnd()).parent().on("dp.change", (e: any) => {
            dpStart.maxDate(e.date);
        });
    }
        
}
Bao.inherit(TaskViewModel, SubscriptionViewModel);
TaskViewModel.prototype.registerMenuClick = function () {
    var self = this;
    BaoMenu.registerEvent(function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            switch (btn.ActionKey()) {
                case "TaskNew":
                    self["new"]();
                    break;
                case "TaskSave":
                    if ((self.IsNew() || self.TabPage.DirtyFlag()) && self.SaveAllowed() && !self.IsHistory()) {
                        self.validate().then(function (isValid) {
                            if (isValid) {
                                self.save();
                            }
                            else {
                                self.showValidationErrors();
                            }
                        });
                    }
                    break;
                case "TaskDelete":
                    self["delete"]();
                    break;
                case 'TaskInProgress':
                    self.taskInProgress();
                    break;
                case "TaskFinish":
                    self.finish();
                    break;
                case "TaskHistory":
                    self.history();
                    break;
                case "TaskSerialEdit":
                    self.TaskSerialEdit();
                    break;
                case "TaskSendMail":
                    self.SendReportMail(self, self.InstructionId());
                    break;
                case "TaskPrint":
                    self.TaskPrint(self, self.InstructionId());
                    break;
                case "TaskApprove":
                    self.approvalDialog();
                    break;
            }
        }
    });
};
TaskViewModel.prototype.canApprove = function () {
    if (!this.IsClosed.peek() && !this.IsHistory.peek() && !this.IsNew.peek()) {
        if (this.IsApprover.peek() && this.IsWaitForApproval.peek()) {
            return true;
        }
    }
    return false;
};
TaskViewModel.prototype.approvalDialog = function () {
    var self = this;
    return Bao.post("Task/TaskApprovalDialog", JSON.stringify({}), function (result) {
        var dialog = new BaoDialog(Bao.Session.ApplicationName);
        dialog.ViewModel(self);
        var approveButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgApprove"), function () {
            self.TabPage.IsLoading(true);
            Bao.post("Task/Approve", JSON.stringify({
                taskId: self.InstructionId()
            })).then(function (approved) {
                self.TabPage.IsLoading(false);
                if (approved > 0) {
                    self.showAlert(finitoService.MessageKeys.TaskApproveSuccessful);
                    self.get().then(function () {
                        self.TabPage.IsLoading(false);
                        self.TabPage.DirtyFlag(false);
                    });
                }
                else {
                    self.showAlert(finitoService.MessageKeys.TaskApproveError, "info");
                }
            });
            dialog.Close();
        });
        var rejectButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgReject"), function () {
            self.TabPage.IsLoading(true);
            Bao.post("Task/Reject", JSON.stringify({
                taskId: self.InstructionId()
            })).then(function (rejected) {
                self.TabPage.IsLoading(false);
                if (rejected > 0) {
                    self.showAlert(finitoService.MessageKeys.TaskRejectSuccessful);
                    self.get().then(function () {
                        self.TabPage.IsLoading(false);
                        self.TabPage.DirtyFlag(false);
                    });
                }
                else {
                    self.showAlert(finitoService.MessageKeys.TaskRejectError, "info");
                }
            });
            dialog.Close();
        });
        var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), function () {
            dialog.Close();
        });
        dialog.Buttons([approveButton, rejectButton, cancelButton]);
        dialog.Template(result.Template);
        dialog.Open();
    });
};
TaskViewModel.prototype.TaskPrint = function (self, modelId) {
    self.TabPage.IsLoading(true);
    Bao.post("Task/Print", JSON.stringify({
        modelId: modelId
    }), function (result) {
        self.TabPage.IsLoading(false);
        if (result.Result == true) {
            baoRouter.setHash("document/" + result.Message);
        }
        else {
            new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
        }
    });
};
TaskViewModel.prototype.SendReportMail = function (self, modelId) {
    self.TabPage.IsLoading(true);
    var dialog = new SendMailDialog(this, modelId, null);
    dialog.DialogTask();
};
TaskViewModel.prototype.canClose = function () {
    var self = this, result = $.Deferred();
    if (self.IsHistory()) {
        result.resolve(true);
    }
    else {
        if (self.TabPage.DirtyFlag() && self.SaveAllowed()) {
            result.resolve(false);
        }
        else {
            result.resolve(true);
        }
    }
    return result.promise();
};
TaskViewModel.prototype.shouldSave = function () {
    var deferred = $.Deferred();
    if (this.TaskbookPermissions?.TaskSave) {
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.SaveCheck), "question");
        dialog.DialogResult.subscribe(function (saveTask) {
            deferred.resolve(saveTask);
        });
    }
    else {
        deferred.resolve(false);
    }
    return deferred.promise();
};
TaskViewModel.prototype.validate = function () {
    var self = this;
    return Bao.post("Task/Validate", JSON.stringify({
        taskModel: ko.map.toJS(self, true)
    }));
};
TaskViewModel.prototype.toggleButtons = function () {
    var self = this;
    var canSave = !self.IsHistory() && self.SaveAllowed() && !self.IsClosed.peek();
    BaoMenu.permissionEnable({
        ActionKey: "TaskSave",
        Enabled: canSave,
        Context: self.TabPage.Context()
    });
    BaoMenu.permissionEnable({
        ActionKey: "TaskDelete",
        Enabled: !self.IsHistory() && !self.IsClosed.peek() && !self.IsNew() && !self.IsPublished.peek(),
        Context: self.TabPage.Context()
    });    
    BaoMenu.permissionEnable({ 
        ActionKey: 'TaskInProgress', 
        Enabled: !self.IsHistory() && !self.IsClosed.peek() && !self.IsNew() && self.CanEditBasedOnApproval.peek(), 
        Context: self.TabPage.Context() 
    });
    BaoMenu.permissionEnable({
        ActionKey: "TaskFinish",
        Enabled: !self.IsHistory() && !self.IsClosed.peek() && !self.IsNew() && self.CanEditBasedOnApproval.peek(),
        Context: self.TabPage.Context()
    });
    BaoMenu.permissionEnable({
        ActionKey: "TaskHistory",
        Enabled: self.HasHistory() && !self.IsNew(),
        Context: self.TabPage.Context()
    });
    BaoMenu.permissionEnable({
        ActionKey: "TaskSerialEdit",
        Enabled: self.SeriesMode(),
        Context: self.TabPage.Context()
    });
    BaoMenu.permissionEnable({
        ActionKey: "TaskSendMail",
        Enabled: !self.IsNew(),
        Context: self.TabPage.Context()
    });
    BaoMenu.permissionEnable({
        ActionKey: "TaskApprove",
        Enabled: self.canApprove(),
        Context: self.TabPage.Context()
    });
};
TaskViewModel.prototype.setTabTitle = function () {
    var self = this;
    self.TabPage.Title(ko.unwrap(self.TabName));
};
TaskViewModel.prototype.getPriorities = function () {
    var self = this;
    return Bao.post("Task/GetPriorities", JSON.stringify({})).then(function (result) {
        ko.map.fromJS(result, self.Priorities);
    });
};
TaskViewModel.prototype.getCategories = function () {
    var self = this;
    return Bao.post("Task/GetCategories", JSON.stringify({
        shiftbookId: self.ShiftbookId()
    })).then(function (result) {
        ko.map.fromJS(result, self.Categories);
    });
};
TaskViewModel.prototype.get = function () {
    var self = this;
    return self.clearSession().then(function () {
        return Bao.post("Task/Get", JSON.stringify({
            taskId: self.InstructionId(),
            infoId: self.InfoId(),
            shiftbookId: self.ShiftbookId()
        }), function (result) {
            ko.map.fromJS(result, self, self.TabPage.DirtyFlag);
            if (result.IsNew) {
                self.TabPage.ObjectId(result.InstructionId);
            }
            self.toggleButtons();
        });
    }).then(function () {
        self.GetAllSerialTaskLinks();
        return self.getRecipients();
    });
};
TaskViewModel.prototype.GetAllSerialTaskLinks = function () {
    let self = this;
    if (!Bao.Utils.String.IsNullOrEmpty(ko.unwrap(self.InstructionSerialId))) {
        if (self.InstructionId() != self.SessionTabId()) {
            self.SessionTabId(ko.unwrap(self.InstructionId));
        }
        Bao.raiseEvent('linked-item:refreshGrid', null);
    }
};
TaskViewModel.prototype.clearSession = function () {
    var self = this;
    let sessionKeyRecipients = 'recipients' + self.InstructionId();
    return Bao.post("Task/ClearSession", JSON.stringify({
        sessionTabId: this.SessionTabId(),
        sessionKeyRecipients: sessionKeyRecipients
    }));
};
TaskViewModel.prototype.getRecipients = function () {
    var self = this;
    return Bao.post("Task/GetRecipients", JSON.stringify({
        taskId: self.InstructionId(),
        sessionTabId: self.SessionTabId(),
        revision: self.Revision()
    }), function (result) {
        self.Instructionrecipients(result);
    });
};
TaskViewModel.prototype["new"] = function () {
    var linkHash = "task/" + Guid();
    baoRouter.setHash(linkHash);
};
TaskViewModel.prototype.save = function (reload) {
    var self = this, deferred = $.Deferred();
    if (reload == null) {
        reload = true;
    }
    if (self.TabPage.DirtyFlag()) {
        var taskModel = ko.map.toJS(self, true);
        taskModel.InstructionAttachment = ko.map.toJS(self.InstructionAttachment);
        if (self.SeriesMode()) {
            taskModel.InstructionSerial = ko.map.toJS(self.InstructionSerial);
        }
        else {
            taskModel.InstructionSerial = null;
        }
        self.TabPage.IsLoading(true);
        Bao.post("Task/Save", JSON.stringify({
            taskModel: taskModel
        })).then(function (saved) {
            if (saved) {
                var defs = [];
                if (typeof self.SubTabsSaveFn !== "undefined" && self.SubTabsSaveFn != false) {
                    ko.utils.arrayForEach(self.SubTabsSaveFn, function (saveFn) {
                        if (typeof saveFn === "function") {
                            defs.push(saveFn());
                        }
                    });
                }
                var subTasksDeferreds = $.when.apply(this, defs);
                self.InstructionId(saved.InstructionId);
                if (typeof self.LinkItemToInfoFn === "function") {
                    self.LinkItemToInfoFn(ko.unwrap(self.InstructionId));
                }
                self.showAlert(finitoService.MessageKeys.TaskSaveSuccessful);
                self.TabPage.DirtyFlag(false);
                if (reload) {
                    self.get().then(function () {
                        self.TabPage.IsLoading(false);
                        self.TabPage.ObjectId(self.InstructionId());
                        self.updateHash(self.InstructionId());
                        self.setTabTitle();
                        subTasksDeferreds.done(function () {
                            deferred.resolve(saved);
                        }).always(function () {
                            self.TabPage.DirtyFlag(false);
                        });
                    });
                }
                else {
                    self.TabPage.IsLoading(false);
                    subTasksDeferreds.done(function () {
                        deferred.resolve();
                    });
                }
                window.dispatchEvent(new CustomEvent("RefreshDashboard"));
            }
            else {
                self.showAlert(finitoService.MessageKeys.TaskSaveError, "info");
                self.TabPage.IsLoading(false);
                deferred.resolve(saved);
            }
            self.setTabTitle();
            Bao.raiseEvent('user-tagging:save', { entityId: self.InstructionId() });
            Bao.raiseEvent("tasks:refresh", {});
        });
    }
    else {
        deferred.resolve(false);
    }
    return deferred.promise();
};
TaskViewModel.prototype.updateHash = function (instructionId) {
    var currentInstructionId = baoRouter.getRouteValue("id", this.TabPage);
    if (currentInstructionId) {
        var newHash = baoRouter.getHash().replace(currentInstructionId, instructionId);
        if (newHash) {
            baoRouter.setHash(newHash);
        }
    }
};

//
// Aufgabe in Bearbeitung
TaskViewModel.prototype.taskInProgress = function () {
    var self = this;
    var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.TaskInProgressQuestion), 'yesno');
    dialog.DialogResult.subscribe(function (shouldInProgress) {
        if (shouldInProgress) {
            self.TabPage.IsLoading(true);
            Bao.post('Task/InProgress', JSON.stringify({
                taskIds: [self.InstructionId()]
            })).then(function (inProgress) {
                self.TabPage.IsLoading(false);
                if (inProgress > 0) {
                    self.showAlert(finitoService.MessageKeys.TaskInProgressSuccessful);
                    self.toggleButtons();
                    self.TabPage.DirtyFlag(false);
                    Bao.raiseEvent('tasks:refresh', {});
                } else {
                    self.toggleButtons();
                    self.showAlert(finitoService.MessageKeys.TaskInProgressError, 'info');
                }
            })
                .then(function () {
                    // tab aktualisieren
                    self.toggleButtons();
                    return self.get();
                });
        }
    });
};

TaskViewModel.prototype.finish = function () {
    var self = this;
    self.canClose().then(function (canClose) {
        if (canClose) {
            self.finishTask();
        }
        else {
            self.shouldSave().then(function (shouldSave) {
                if (shouldSave === true) {
                    self.save().then(function () {
                        self.finishTask();
                    });
                }
                else if (shouldSave === false) {
                    self.finishTask();
                }
                else { }
            });
        }
    });
};
TaskViewModel.prototype.finishTask = function () {
    var self = this;
    var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.TaskFinishQuestion), "yesno");
    dialog.DialogResult.subscribe(function (shouldFinish) {
        if (shouldFinish) {
            self.TabPage.IsLoading(true);
            Bao.post("Task/Finish", JSON.stringify({
                taskIds: [self.InstructionId()]
            })).then(function (finished) {
                self.toggleButtons();
                self.TabPage.IsLoading(false);
                if (finished > 0) {
                    self.showAlert(finitoService.MessageKeys.TaskFinishSuccessful);
                    self.TabPage.DirtyFlag(false);
                    Bao.raiseEvent("tasks:refresh", {});
                }
                else {
                    self.showAlert(finitoService.MessageKeys.TaskFinishError, "info");
                }
            }).then(function () {
                self.toggleButtons();
                return self.get();
            });
        }
    });
};
TaskViewModel.prototype["delete"] = function () {
    var self = this;
    var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.TaskDeleteQuestion), "yesno");
    dialog.DialogResult.subscribe(function (canDelete) {
        if (canDelete) {
            self.TabPage.IsLoading(true);
            return Bao.post("Task/Delete", JSON.stringify({
                taskIds: [self.InstructionId()]
            })).then(function (deleted) {
                if (deleted > 0) {
                    self.showAlert(finitoService.MessageKeys.TaskDeleteSuccessful);
                    self.TabPage.DirtyFlag(false);
                    self.dispose();
                    self.AppTabController.RemoveTab(self.TabPage);
                    Bao.raiseEvent("tasks:refresh", {});
                }
                else {
                    self.showAlert(finitoService.MessageKeys.TaskDeleteError, "info");
                }
                self.TabPage.IsLoading(false);
            });
        }
    });
};
TaskViewModel.prototype.forward = function () { };
TaskViewModel.prototype.backward = function () { };
TaskViewModel.prototype.getTaskBooks = function () {
    var self = this;
    return Bao.post("Shiftbook/GetTaskBooksForCurrentUser").then(function (serverResult) {
        if (serverResult.TaskBooksForCurrentUser.some(element => element.ShiftbookId === self.ShiftbookId()) === false) {
            var assignedShiftbookToCurrentTask = {
                ShiftbookId: self.ShiftbookId(),
                Name: self.ShiftbookName()
            };
            self.TaskBooks().push(assignedShiftbookToCurrentTask);
        }
        if (serverResult.TaskBooksForCurrentUser.length > 0) {
            serverResult.TaskBooksForCurrentUser.forEach(element => self.TaskBooks.push(element));
        }
        else {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedTaskBooks"), "info");
        }
    });
};
TaskViewModel.prototype.addRecipients = function (recipients) {
    var self = this;
    var def = $.Deferred();
    self.TabPage.IsLoading(true);
    self.TabPage.DirtyFlag(true);
    Bao.post("Task/AddRecipients", JSON.stringify({
        taskId: self.InstructionId(),
        revision: self.Revision(),
        recipients: recipients,
        sessionTabId: self.SessionTabId()
    }), function () {
        self.getRecipients().then(function () {
            self.TabPage.IsLoading(false);
            def.resolve();
        });
    });
    return def.promise();
};
TaskViewModel.prototype.getIdsFromRecipientString = function (recipientString) {
    var result = [];
    var rsArray = recipientString.split("|");
    if (rsArray && rsArray.length > 0) {
        result[0] = rsArray[0] ? rsArray[0] : null;
        result[1] = rsArray[1] ? rsArray[1] : null;
        result[2] = rsArray[2] ? rsArray[2] : null;
    }
    return result;
};
TaskViewModel.prototype.getHistory = function (historyItem) {
    var self = this;
    self.BeforeClose(function () {
        self.TabPage.IsLoading(true);
        self.TabPage.DirtyFlag(false);
        if (historyItem) {
            if (historyItem.IsNewestRevision()) {
                self.get().then(() => {
                    Bao.raiseEvent('linked-item:refreshToolbarButton', null);
                    if (self.TextModuleField() != undefined ) {

                        finitoService.setTextToUserTaggingInput(self.TextModuleField().querySelector("#userTaggingInput"), historyItem.InstructionText(),false)
                    }
                    self.toggleButtons();
                    self.setTabTitle();
                    self.TabPage.IsLoading(false);
                });
            }
            else {
                self.clearSession().then(function () {
                    Bao.post("Task/GetHistory", JSON.stringify({
                        instructionHistoryId: historyItem.InstructionHistoryId()
                    })).then(function (result) {
                        ko.map.fromJS(result, self, self.TabPage.DirtyFlag);
                        Bao.raiseEvent('linked-item:refreshToolbarButton', null);
                        if (self.TextModuleField() != undefined && result != undefined) {

                            finitoService.setTextToUserTaggingInput(self.TextModuleField().querySelector("#userTaggingInput"), result.InstructionText, result.IsHistory)
                        }
                        self.getRecipients().then(function () {
                            self.toggleButtons();
                            self.setTabTitle();
                            self.TabPage.IsLoading(false);
                        });
                    });
                });
            }
        }
    }, true);
};
TaskViewModel.prototype.history = function () {
    var self = this;
    Bao.get("Task/History", $.param({
        instructionId: self.InstructionId()
    })).then(function (html) {
        var dialog = new BaoDialog(Bao.Session.GetMessage("msgHistory"));
        dialog.ViewModel(new TaskHistoryViewModel(self.InstructionId(), function (historyItem) {
            self.getHistory(historyItem);
            dialog.Close();
        }));
        dialog.Template(html);
        dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (dialog.ViewModel().Selection()) {
                    self.getHistory(dialog.ViewModel().Selection()[0]);
                }
                dialog.Close();
            },
            Enabled: dialog.ViewModel().HasSelection
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
        dialog.ViewModel().initialize();
        dialog.Open();
    });
};
TaskViewModel.prototype.TaskSerialEdit = function () {
    var self = this;
    if (self.SeriesMode()) {
        self.TabPage.IsLoading(true);
        window.baorequire(["ViewModels/Dialogs/InstructionSerialDialog"], function (vm) {
            var dialog;
            if (self.InstructionSerialId() != null) {
                dialog = new vm(self.InstructionSerial, self.ValidFromHtml());
            }
            else {
                dialog = new vm(null, self.ValidFromHtml());
            }
            dialog.Show(self.InstructionSerialId());
            self.TabPage.IsLoading(false);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "delete") {
                    Bao.post("Instruction/DeleteInstructionSerial", JSON.stringify({
                        instructionSerialId: self.InstructionSerialId()
                    }), function () {
                        Bao.raiseEvent("tasks:refresh", {});
                        self.TabPage.DirtyFlag(false);
                        self.TabPage.$TabController.RemoveTab(self.TabPage);
                    });
                }
                else if (dialogResult != null) {
                    Bao.post("Instruction/RefreshSerialModel", JSON.stringify({
                        instructionSerialModel: dialogResult
                    }), function (instructionSerialModel) {
                        ko.map.fromJS(instructionSerialModel, self.InstructionSerial);
                        self.InstructionSerialId(instructionSerialModel.InstructionSerialId);
                        self.SeriesMode(true);
                    });
                }
            });
        });
    }
};
TaskViewModel.prototype.SetParentsByDevice4 = function () {
    var self = this;
    var def = $.Deferred();
    if (self.IgnoreDeviceChanges() == false) {
        if (self.Device4Id() != null) {
            self.TabPage.IsLoading(true);
            self.IgnoreDeviceChanges(true);
            Bao.post("Device/Device4Parents", JSON.stringify({
                device4Id: self.Device4Id()
            }), function (result) {
                if (result != null) {
                    if (result.Device3Id != null && self.Device3Id() == null && Bao.Utils.String.IsNullOrWhitespace(self.Device3NameBinding())) {
                        self.Device3Id(result.Device3Id);
                        self.Device3NameBinding(result.Device3Name);
                    }
                    if (result.AreaEquipmentId != null && self.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaEquipmentBinding())) {
                        self.AreaEquipmentId(result.AreaEquipmentId);
                        self.AreaEquipmentBinding(result.AreaEquipmentName);
                    }
                    if (result.AreaId != null && self.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaName())) {
                        self.AreaId(result.AreaId);
                        self.AreaName(result.AreaName);
                    }
                }
            }).always(function () {
                self.TabPage.IsLoading(false);
                self.IgnoreDeviceChanges(false);
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
    }
    else {
        def.resolve();
    }
    return def.promise();
};
TaskViewModel.prototype.SetParentsByDevice3 = function () {
    var self = this;
    var def = $.Deferred();
    if (self.IgnoreDeviceChanges() == false) {
        self.IgnoreDeviceChanges(true);
        if (self.Device3Id() != null) {
            self.TabPage.IsLoading(true);
            $.when(Bao.post("Device/Device3Parents", JSON.stringify({
                device3Id: self.Device3Id()
            }), function (result) {
                if (result != null) {
                    if (result.AreaEquipmentId != null && self.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaEquipmentBinding())) {
                        self.AreaEquipmentId(result.AreaEquipmentId);
                        self.AreaEquipmentBinding(result.AreaEquipmentName);
                    }
                    if (result.AreaId != null && self.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaName())) {
                        self.AreaId(result.AreaId);
                        self.AreaName(result.AreaName);
                    }
                }
            }), Bao.post("Device/Device3Children", JSON.stringify({
                device3Id: self.Device3Id(),
                device4Id: self.Device4Id()
            }), function (result) {
                if (result != null) {
                    if (result.Device4 == false) {
                        self.Device4Id(null);
                        self.Device4NameBinding(null);
                    }
                }
            })).always(function () {
                self.TabPage.IsLoading(false);
                self.IgnoreDeviceChanges(false);
                def.resolve();
            });
        }
        else {
            self.Device4Id(null);
            self.Device4NameBinding(null);
            self.IgnoreDeviceChanges(false);
            def.resolve();
        }
    }
    else {
        def.resolve();
    }
    return def.promise();
};
TaskViewModel.prototype.SetParentsByAreaEquipment = function () {
    var self = this;
    var def = $.Deferred();
    if (self.IgnoreDeviceChanges() == false) {
        self.IgnoreDeviceChanges(true);
        if (self.AreaEquipmentId() != null) {
            self.TabPage.IsLoading(true);
            $.when(Bao.post("Device/AreaEqupimentParents", JSON.stringify({
                areaEquipmentId: self.AreaEquipmentId()
            }), function (result) {
                if (result != null) {
                    if (result.AreaId != null && self.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaName())) {
                        self.AreaId(result.AreaId);
                        self.AreaName(result.AreaName);
                    }
                }
            }), Bao.post("Device/AreaEquipmentChildren", JSON.stringify({
                areaEquipmentId: self.AreaEquipmentId(),
                device3Id: self.Device3Id(),
                device4Id: self.Device4Id()
            }), function (result) {
                if (result != null) {
                    if (result.Device3 == false) {
                        self.Device3Id(null);
                        self.Device3NameBinding(null);
                    }
                    if (result.Device4 == false) {
                        self.Device4Id(null);
                        self.Device4NameBinding(null);
                    }
                }
            })).always(function () {
                self.TabPage.IsLoading(false);
                self.IgnoreDeviceChanges(false);
                def.resolve();
            });
        }
        else {
            self.Device3Id(null);
            self.Device3NameBinding(null);
            self.Device4Id(null);
            self.Device4NameBinding(null);
            self.IgnoreDeviceChanges(false);
            def.resolve();
        }
    }
    else {
        def.resolve();
    }
    return def.promise();
};
TaskViewModel.prototype.SetChildrenByArea = function () {
    var self = this;
    var def = $.Deferred();
    if (self.IgnoreDeviceChanges() == false) {
        self.IgnoreDeviceChanges(true);
        if (self.AreaId() != null) {
            self.TabPage.IsLoading(true);
            Bao.post("Device/AreaChildren", JSON.stringify({
                areaId: self.AreaId(),
                areaEquipmentId: self.AreaEquipmentId(),
                device3Id: self.Device3Id(),
                device4Id: self.Device4Id()
            }), function (result) {
                if (result != null) {
                    if (result.AreaEquipment == false) {
                        self.AreaEquipmentId(null);
                        self.AreaEquipmentBinding(null);
                    }
                    if (result.Device3 == false) {
                        self.Device3Id(null);
                        self.Device3NameBinding(null);
                    }
                    if (result.Device4 == false) {
                        self.Device4Id(null);
                        self.Device4NameBinding(null);
                    }
                }
            }).always(function () {
                self.TabPage.IsLoading(false);
                self.IgnoreDeviceChanges(false);
                def.resolve();
            });
        }
        else {
            self.AreaEquipmentBinding(null);
            self.AreaEquipmentId(null);
            self.Device3Id(null);
            self.Device3NameBinding(null);
            self.Device4Id(null);
            self.Device4NameBinding(null);
            self.IgnoreDeviceChanges(false);
            def.resolve();
        }
    }
    return def.promise();
};
export default TaskViewModel;